'use client'

import { useSyncExternalStore } from 'react'
import { USER_IDENTITY_SET_EVENT } from '@/utilities/client/userIdentityEvent'

let identityVersion = 0
let isListening = false
const listeners = new Set<() => void>()

function handleIdentityChange() {
  identityVersion += 1
  listeners.forEach((listener) => listener())
}

function subscribe(listener: () => void) {
  if (!isListening) {
    globalThis.addEventListener(USER_IDENTITY_SET_EVENT, handleIdentityChange)
    isListening = true
  }

  listeners.add(listener)
  return () => {
    listeners.delete(listener)
    if (listeners.size === 0 && isListening) {
      globalThis.removeEventListener(USER_IDENTITY_SET_EVENT, handleIdentityChange)
      isListening = false
    }
  }
}

function getSnapshot() {
  return identityVersion
}

export function useClientIdentityVersion(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
